import { clearLocalStorageKeeping } from "./tillDeviceRegistration";

// "POS Failed to Start" screen, drawn without React when the app cannot start.
// Both clear buttons clear local storage only -- the local tables stay -- so this
// browser keeps its device id (BUG-2621: without it the same browser came back as
// another device holding its own till).
export function renderFatalError(error, container = document.getElementById("root")) {
  if (!container) return;
  container.innerHTML = `
    <div style="position:fixed;top:0;left:0;width:100vw;height:100vh;background:#f8f9fa;display:flex;align-items:center;justify-content:center;font-family:Inter,-apple-system,BlinkMacSystemFont,sans-serif">
      <div style="background:#fff;border-radius:12px;padding:32px;width:480px;max-width:90vw;box-shadow:0 4px 24px rgba(0,0,0,0.12);text-align:center">
        <div style="width:48px;height:48px;background:#FEE4E2;border-radius:999px;display:flex;align-items:center;justify-content:center;font-size:22px;margin:0 auto 20px">&#9888;</div>
        <h2 style="font-size:18px;font-weight:600;color:#101828;margin-bottom:8px">POS Failed to Start</h2>
        <p style="font-size:14px;color:#475467;margin-bottom:16px">The application could not initialize. This is usually caused by corrupted cache data.</p>
        <div style="background:#FEF3F2;border:1px solid #FEE4E2;border-radius:6px;padding:8px 12px;font-size:12px;color:#B42318;margin-bottom:20px;word-break:break-word;max-height:60px;overflow:auto">${error?.message || "Unknown startup error"}</div>
        <div style="display:flex;gap:8px;justify-content:center">
          <button data-action="login" style="background:#fff;border:1px solid #D0D5DD;color:#344054;padding:8px 14px;font-size:13px;font-weight:500;border-radius:8px;cursor:pointer">Go to Login</button>
          <button data-action="clear" style="background:#FEF3F2;border:1px solid #FEE4E2;color:#B42318;padding:8px 14px;font-size:13px;font-weight:500;border-radius:8px;cursor:pointer">Clear Cache & Reload</button>
          <button data-action="reload" style="background:#2970FF;border:none;color:#fff;padding:8px 14px;font-size:13px;font-weight:500;border-radius:8px;cursor:pointer">Reload POS</button>
        </div>
      </div>
    </div>`;
  const on = (action, fn) => container.querySelector(`[data-action="${action}"]`)?.addEventListener("click", fn);
  on("login", () => {
    try {
      clearLocalStorageKeeping();
    } catch (e) {
      /* storage blocked: go on to the login */
    }
    window.location.href = "/sign-in";
  });
  on("clear", () => {
    try {
      clearLocalStorageKeeping(["authTokens", "oAuthData"]);
    } catch (e) {
      /* storage blocked: go on to the till screen */
    }
    window.location.href = "/till";
  });
  on("reload", () => window.location.reload());
}
